import { ref } from 'vue'

interface ConfirmState {
    visible: boolean
    message: string
    title: string
    resolve: ((value: boolean) => void) | null
}

const state = ref<ConfirmState>({
    visible: false,
    message: '',
    title: 'Confirmar',
    resolve: null,
})

export function useConfirm() {
    function confirm(message: string, title = 'Confirmar'): Promise<boolean> {
        return new Promise((resolve) => {
            state.value = { visible: true, message, title, resolve }
        })
    }

    function accept() {
        state.value.resolve?.(true)
        state.value.visible = false
    }

    function cancel() {
        state.value.resolve?.(false)
        state.value.visible = false
    }

    return { state, confirm, accept, cancel }
}
